import type { BossRevealCircleVariant, BossRevealEffect } from "../types";
import { mediaUrl } from "./media-url";

export const BOSS_REVEAL_DURATION_MS = 12_000;
export const BOSS_REVEAL_CLEANUP_GRACE_MS = 1_000;
export const BOSS_REVEAL_CIRCLE_VARIANTS: readonly BossRevealCircleVariant[] = ["runic", "void", "infernal"];

export const BOSS_REVEAL_MUSIC_TRACKS = Array.from({ length: 9 }, (_, index) => {
  const number = String(index + 1).padStart(2, "0");
  return { id: `iron-warden-${number}`, url: mediaUrl(`/assets/audio/boss-reveal/iron-warden-${number}.mp3`) };
});

export function bossRevealMusicUrl(trackId: string | undefined) {
  return BOSS_REVEAL_MUSIC_TRACKS.find((track) => track.id === trackId)?.url;
}

export function randomBossRevealMusicTrackId(random = Math.random) {
  const sample = Math.max(0, Math.min(0.9999999999999999, random()));
  return BOSS_REVEAL_MUSIC_TRACKS[Math.floor(sample * BOSS_REVEAL_MUSIC_TRACKS.length)].id;
}

export function randomBossRevealCircleVariant(random = Math.random) {
  const sample = Math.max(0, Math.min(0.9999999999999999, random()));
  return BOSS_REVEAL_CIRCLE_VARIANTS[Math.floor(sample * BOSS_REVEAL_CIRCLE_VARIANTS.length)];
}

export function bossRevealIsActive(effect: BossRevealEffect | undefined, sceneId: string | undefined, now = Date.now()) {
  return Boolean(effect && effect.sceneId === sceneId && now - effect.startedAt < effect.durationMs + BOSS_REVEAL_CLEANUP_GRACE_MS);
}
